import { render, staticRenderFns } from "./GrantSubWizardTab.vue?vue&type=template&id=63aa7914&"
import script from "./GrantSubWizardTab.vue?vue&type=script&lang=js&"
export * from "./GrantSubWizardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports